import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Typography, Grid2, Divider } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { fetchDeploymentData } from "../services/api";
import { toast, Bounce } from "react-toastify";
import RecentTrades from "../components/RecentTrades";
import DeploymentHistory from '../components/DeploymentHistory';
import moment from 'moment';


const DeploymentDetails = () => {
    const [loading, setLoading] = useState(true);
    const { deploymentId } = useParams();
    const [deploymentData, setDeploymentData] = useState(null);

    useEffect(() => {
        fetchDeploymentDetails(deploymentId);
    }, [deploymentId]);

    const fetchDeploymentDetails = (deploymentId) => {
        setLoading(true)
        fetchDeploymentData(deploymentId)
            .then((response) => {
                setDeploymentData(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching deployment:", error);
                showToast("error", "Error fetching deployment!");
            });
    };

    const showToast = (type, message) => {
        let properties = {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        }
        switch (type) {
            case "success":
                toast.success(message, properties);
                break;
            case "error":
                toast.error(message, properties);
                break;
            case "warning":
                toast.warn(message, properties);
                break;
            default:
                toast.info(message, properties);
        }
    }

    if (!deploymentData) {
        return <Typography>Loading...</Typography>;
    }

    const { deployment, deploymentHistory, trades, pnl_data, funds_data } = deploymentData;

    const pnlData = deploymentHistory.slice().reverse()
        // .filter(deploymentState => { return deploymentState.status == "scanning_for_entry_signal" })
        .map(deploymentState => {
            return {
                timestamp: moment(deploymentState.updated_at).format("hh:mm"),
                pnl: deploymentState.net_pnl
            };
        });

    const fundsData = deploymentHistory.slice().reverse()
        // .filter(deploymentState => { return deploymentState.status == "scanning_for_entry_signal" })
        .map(deploymentState => {
            return {
                timestamp: moment(deploymentState.updated_at).format("hh:mm"),
                funds_balance: deploymentState.funds_balance
            };
        });

    return (
        <Grid2 container spacing={3}>
            <Grid2 item size={2}>
                <Card>
                    <CardContent>
                        <Typography variant="h5">Deployment ID: {deploymentId}</Typography>
                        <Typography variant="subtitle1">Status: {deployment.status}</Typography>
                        {/* <Typography>Session ID: {deployment.session_id}</Typography> */}
                        {/* <Typography>Strategy ID: {deployment.strategy_id}</Typography> */}
                        <Typography>Funds Allocated: ₹{deployment.funds_allocated.toLocaleString('en-IN')}</Typography>
                        <br />
                        {/* <Typography>Funds Balance: ₹{deployment.funds_balance.toLocaleString('en-IN')}</Typography> */}
                        <Typography>Gross PnL: ₹{deployment.pnl.toLocaleString('en-IN')}</Typography>
                        <Typography>Charges: ₹{(deployment.brokerage_charges + deployment.other_charges).toLocaleString('en-IN')}</Typography>
                        <Typography>Net PnL: ₹{deployment.net_pnl.toLocaleString('en-IN')}</Typography>
                        <br />
                        <Typography>Max Net PnL: ₹{deployment.max_net_pnl.toLocaleString('en-IN')}</Typography>
                        <Typography>Min Net PnL: ₹{deployment.min_net_pnl.toLocaleString('en-IN')}</Typography>
                    </CardContent>
                </Card>
            </Grid2>

            <Grid2 item size={5}>
                <Card>
                    <CardContent>
                        <Typography variant="h6">PnL Overview</Typography>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={pnlData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="timestamp" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Line type="monotone" dataKey="pnl" stroke="#82ca9d" />
                            </LineChart>
                        </ResponsiveContainer>
                    </CardContent>
                </Card>
            </Grid2>

            <Grid2 item size={5}>
                <Card>
                    <CardContent>
                        <Typography variant="h6">Funds Balance Overview</Typography>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={fundsData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="timestamp" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Line type="monotone" dataKey="funds_balance" stroke="#8884d8" />
                            </LineChart>
                        </ResponsiveContainer>
                    </CardContent>
                </Card>
            </Grid2>

            <Grid2 item size={12}>
                <DeploymentHistory data={deploymentHistory}></DeploymentHistory>
            </Grid2>


            <Grid2 item size={12}>
                <RecentTrades data={trades} />
            </Grid2>
        </Grid2>
    );
};

export default DeploymentDetails;
